import React from 'react';
export function EllipsisVerticalIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.003a2 2 0 10.006-4 2 2 0 00-.006 4zM12 14.003a2 2 0 10.006-4 2 2 0 00-.006 4zM12 20.003a2 2 0 10.006-4 2 2 0 00-.006 4z"
  }));
}